import { render, staticRenderFns } from "./CategoriesListView.vue?vue&type=template&id=413ee3e1&"
import script from "./CategoriesListView.vue?vue&type=script&lang=js&"
export * from "./CategoriesListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports